import React from "react";
import Lottie from "lottie-react";
import searchAnimation from "../../Assets/Icons/search.json";

const LoadingSearch: React.FC = () => {
  return (
    <div className="h-screen flex flex-col justify-center items-center bg-gradient-to-r from-white via-yellow-50 to-yellow-100">
      {/* Ikon animasi Lottie */}
      <div className="w-40 h-40 mb-2">
        <Lottie animationData={searchAnimation} loop={true} />
      </div>

      {/* Teks */}
      <p className="text-lg font-semibold text-gray-700">Mencari Informasi Terbaru..</p>
    </div>
  );
};

export default LoadingSearch;
